/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_ReviewInputs */

const en_import_review = /** @type {(inputs: Import_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review`)
};

const de_import_review = /** @type {(inputs: Import_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen`)
};

/**
* | output |
* | --- |
* | "Review" |
*
* @param {Import_ReviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_review = /** @type {((inputs?: Import_ReviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_ReviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_review(inputs)
	return en_import_review(inputs)
});